import { manageMobileMenu } from '@/components/mobileMenu'
import { setupSliders } from '@/components/slider'
import { lazyImages } from '@/components/lazyImages'
import { trackShortlist } from '@/components/shortlist'
import { dragToScroll } from '@/components/categoryBar'
import { init as animate } from '@/components/animate'

animate()
manageMobileMenu()
setupSliders()
lazyImages()
trackShortlist()
dragToScroll()


